/**
 * Function builds tracking parameters
 * @returns string
 */

export default function getTrackingParams(source: string): string {
  return encodeURIComponent(`?utm_medium=social&utm_campaign=socialbuttons&utm_source=${source}`);
}
